import { CapoPlugin } from "/usr/code/docker/www/formx/client/node_modules/@unhead/vue/dist/index.mjs";
export default import.meta.server ? [CapoPlugin({ track: true })] : [];